/* tslint:disable:typedef-whitespace align no-trailing-whitespace import-spacing */

import {Action, ActionType}    from '@/models/action';
import {Logger}                from '@/util/logger';
import {TextEditorMetadata}    from '@/screens/ide/text.editor.metadata';
import {WindowService}         from "@/services/window.service";

/**
 *
 * @class TextEditAction
 *
 * @brief launch a fresh (text) editor tab
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2020
 *
 */
export class TextEditAction extends Action {

  private      windows: WindowService = null;

  constructor(options: any = null) {

    super({
      key:   'window.textedit',
      type:  ActionType.Window_TextEdit,
      label: 'Text Edit (Empty)',
      icon:  '<i class="fas fa-keyboard"></i>',
      tip:   'Launch a text editor'
    });

    this.windows  = this.injector().get(WindowService);
  }

  /* is this action enabled? */
  public enabled(): boolean {

    return true;
  }

  /** implement the action */
  public execute(): boolean {

    if (!this.enabled()) {
      return false;
    }

    Logger.debug('[TextEditAction] executing...');

    this.windows.launchWindow(new TextEditorMetadata(
      '',
      '',
      ''
    ));

    return true;
  }
}
